import { Prescription } from '@lyrahealth-inc/shared-app-logic/src/models/prescription/Prescription'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

type GetPatientPrescriptionsArgs = {
  clientId: string
  startDate?: string
  endDate?: string
}

type GetPatientPrescriptionsResponse = {
  Items: Prescription[]
}

type GetDSPatientUrlArgs = {
  clientId: string
}

type GetDSPatientUrlResponse = {
  sso_url: string
}

type GetDSPrescriptionsNotificationsUrlArgs = {
  providerId: string
}

type GetDSPrescriptionsNotificationsUrlResponse = {
  sso_url: string
}

type DeletePrescriptionArgs = {
  clientId: string
  prescriptionId: number
}

const medicationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientPrescriptions: builder.query<Prescription[], GetPatientPrescriptionsArgs>({
      query: ({ clientId, startDate, endDate }) => {
        const params = new URLSearchParams()

        if (startDate && endDate) {
          params.append('startDate', startDate)
          params.append('endDate', endDate)
        }

        const queryString = params.toString()
        const url = `/meds/v1/patients/${clientId}/prescriptions${queryString ? `?${queryString}` : ''}`

        return {
          method: 'get',
          url,
          ignore404: true,
        }
      },
      transformResponse: (response: GetPatientPrescriptionsResponse) => {
        return response.Items
      },
      providesTags: [RTKQueryTag.MEDICATIONS],
    }),
    getDSPatientUrl: builder.query<GetDSPatientUrlResponse, GetDSPatientUrlArgs>({
      query: ({ clientId }) => ({
        method: 'get',
        url: `/meds/v1/patients/${clientId}/sso/url`,
      }),
    }),
    getDSPrescriptionsNotificationsUrl: builder.query<
      GetDSPrescriptionsNotificationsUrlResponse,
      GetDSPrescriptionsNotificationsUrlArgs
    >({
      query: ({ providerId }) => ({
        method: 'get',
        url: `/meds/v1/providers/${providerId}/refills/sso/url`,
      }),
    }),
    deletePrescription: builder.mutation<void, DeletePrescriptionArgs>({
      query: ({ clientId, prescriptionId }) => ({
        method: 'delete',
        url: `/meds/v1/patients/${clientId}/prescriptions/${prescriptionId}`,
      }),
      invalidatesTags: [RTKQueryTag.MEDICATIONS],
    }),
  }),
})

export const {
  useGetPatientPrescriptionsQuery,
  useLazyGetDSPatientUrlQuery,
  useLazyGetDSPrescriptionsNotificationsUrlQuery,
  useDeletePrescriptionMutation,
} = medicationsApi
export default medicationsApi
